<template>
    <div class="available-colors-tabs">
        <div class="available-colors-tabs-head">
            <button v-for="(tab, idx) in tabs" :key="idx" type="button"
                :class="['available-colors-tab', { active: activeTabIndex === idx }]" @click="activeTabIndex = idx">
                <span> {{ tab.label }}</span>
            </button>
        </div>
        <div class="available-colors-tabs-body">
            <div v-for="(tab, idx) in tabs" v-show="activeTabIndex === idx" :key="idx"
                class="available-colors-tab-panel">
                <div class="available-colors-panel-inner">
                    <div v-if="tabColors(idx).length > 0" class="fullscreen-trigger" @click="openFullScreen(idx)"
                        title="Open full screen">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 10L14 14" stroke="#1D6CB5" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M10 6L14 2" stroke="#1D6CB5" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M13.9974 10.668V14.0013H10.6641" stroke="#1D6CB5" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.9974 5.33333V2H10.6641" stroke="#1D6CB5" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M2 10.668V14.0013H5.33333" stroke="#1D6CB5" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M2 14L6 10" stroke="#1D6CB5" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M2 5.33333V2H5.33333" stroke="#1D6CB5" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M6 6L2 2" stroke="#1D6CB5" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <!-- Empty State Message -->
                    <div v-if="tabColors(idx).length === 0" class="empty-state-message">
                        <span v-if="tabs[idx].key === 'stock'">No stock colors available.</span>
                        <span v-else-if="tabs[idx].key === 'specialty'">No specialty colors available.</span>
                        <span v-else-if="tabs[idx].key === 'inkOrThread'">{{ getEmptyCustomMessage() }}</span>
                    </div>
                    
                    <div v-else class="ui-palette-box color_boxes_design available-colors-grid"
                        :class="{ 'has-fullscreen': tabColors(idx).length > 0, 'scrollable-grid': tabColors(idx).length > 40 }">
                        <div v-for="(color, index) in tabColors(idx)" :key="index" class="swatch-wrap">
                            <div v-if="color.swatch_file != null && color.swatch_file" :title="color.color_name"
                                :class="['marign_color', isColorSelected(color, index, idx) ? 'selected_color' : '', isColorSelected(color, index, idx) && isDarkColor(color) ? 'tick-on-dark' : '']"
                                @click="$emit('select', color)" style="display: grid;" v-tooltip="color.color_value">
                                <img :src="color.swatch_file" alt="img" class="swatch_img_tag_add_new" />
                                <div class="input_color_check_box">
                                    <form>
                                        <div class="form-group">
                                            <span v-if="isColorSelected(color, index, idx)"
                                                :class="['input_color_check_box_dot_icon', isDarkColor(color) ? 'dot-on-dark' : '']"></span>
                                            <input type="checkbox" :checked="isColorSelected(color, index, idx)" />
                                            <label for="html"></label>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div v-else :title="color.color_name"
                                :class="['marign_color', isColorSelected(color, index, idx) ? 'selected_color' : '', isColorSelected(color, index, idx) && isDarkColor(color) ? 'tick-on-dark' : '']"
                                @click="$emit('select', color)"
                                :style="'display: grid; background:' + (color.color_value || '') + ';'" v-tooltip="{
                                    content: `${color.color_name || ''}<br/>${color.color_value || ''}<br/>${color.color_pms || ''}`,
                                    html: true
                                }">
                                <div class="input_color_check_box">
                                    <form>
                                        <div class="form-group">
                                            <span v-if="isColorSelected(color, index, idx)"
                                                :class="['input_color_check_box_dot_icon', isDarkColor(color) ? 'dot-on-dark' : '']"></span>
                                            <input type="checkbox" :checked="isColorSelected(color, index, idx)" />
                                            <label for="html"></label>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AvailableColorsTabs",
    props: {
        stockColors: { type: Array, default: () => [] },
        customInkOrThreadColors: { type: Array, default: () => [] },
        specialtyColors: { type: Array, default: () => [] },
        showCustomInkTab: { type: Boolean, default: true },
        showCustomInkOrThreadTab: { type: Boolean, default: true },
        decorationType: { type: [Number, String], default: 0 },
        colorType: { type: String, default: '' },
        selectedColor: { type: [String, undefined], default: undefined },
        selectedColorPms: { type: [String, undefined], default: undefined },
        selectedColorId: { type: [Number, String, undefined], default: undefined },
        colorListValue: { type: Array, default: () => [] }
    },
    data() {
        return {
            activeTabIndex: 0
        };
    },
    computed: {
        normalizedColorType() {
            return (this.colorType || "")
                .toString()
                .trim()
                .toLowerCase();
        },
        tabs() {
            let inkOrThreadLabel = "Custom Colors";

            if (
                this.normalizedColorType &&
                this.normalizedColorType !== "none"
            ) {
                if (this.normalizedColorType.includes("thread")) {
                    inkOrThreadLabel = "Custom Thread Color";
                } else if (this.normalizedColorType.includes("ink")) {
                    inkOrThreadLabel = "Custom Ink Color";
                } else {
                    inkOrThreadLabel = "Custom Colors";
                }
            } else {
                inkOrThreadLabel = "Custom Colors";
            }
            
            if (this.showCustomInkOrThreadTab) {
                return [
                    { key: "stock", label: "Stock" },
                    { key: "inkOrThread", label: inkOrThreadLabel },
                    { key: "specialty", label: "Specialty Color" }
                ];
            }
            return [
                { key: "stock", label: "Stock" },
                { key: "specialty", label: "Specialty Color" }
            ];
        }
    },
    methods: {
        tabColors(idx) {
            if (this.showCustomInkOrThreadTab) {
                if (idx === 0) return this.stockColors || [];
                if (idx === 1) return this.customInkOrThreadColors || [];
                if (idx === 2) return this.specialtyColors || [];
            } else {
                if (idx === 0) return this.stockColors || [];
                if (idx === 1) return this.specialtyColors || [];
            }
            return [];
        },
        getEmptyCustomMessage() {
            if (
                this.normalizedColorType &&
                this.normalizedColorType.includes("thread")
            ) {
                return "No custom thread colors available.";
            }
            if (
                this.normalizedColorType &&
                this.normalizedColorType.includes("ink")
            ) {
                return "No custom ink colors available.";
            }
            return "No custom colors available.";
        },
        toHex(val) {
            if (!val || typeof val !== "string") return (val || "").toString().trim().toLowerCase();
            const rgb = /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(val);
            if (rgb) {
                const r = parseInt(rgb[1], 10);
                const g = parseInt(rgb[2], 10);
                const b = parseInt(rgb[3], 10);
                return "#" + [r, g, b].map((x) => ("0" + Math.max(0, Math.min(255, x)).toString(16)).slice(-2)).join("");
            }
            return val.trim().toLowerCase();
        },
        /** Tab and index of selected color (by id). */
        getSelectedColorTabAndIndex() {
            if (this.selectedColorId == null) return null;
            const tabCount = this.tabs.length;
            for (let i = 0; i < tabCount; i++) {
                const colors = this.tabColors(i);
                const idx = colors.findIndex((c) => c.color_id === this.selectedColorId);
                if (idx >= 0) return { tabIdx: i, index: idx };
            }
            return null;
        },
        /** Tab to show check for this hex. Prefer Specialty then Custom then Stock when no selection. */
        getChosenTabForHex(listHex) {
            const h = this.toHex(listHex);
            const sel = this.getSelectedColorTabAndIndex();
            if (sel) {
                const colors = this.tabColors(sel.tabIdx);
                const c = colors[sel.index];
                if (c && this.toHex(c.color_value) === h) return sel.tabIdx;
            }
            const tabCount = this.tabs.length;
            for (let i = tabCount - 1; i >= 0; i--) {
                if (this.tabColors(i).some((c) => this.toHex(c.color_value) === h)) return i;
            }
            return null;
        },
        /** Match hex + PMS so one swatch per variant. */
        swatchMatchesHexAndPms(color, hex) {
            if (!color || this.toHex(color.color_value) !== hex) return false;
            if (this.selectedColorPms == null || this.selectedColorPms === "") return true;
            const pms = (color.color_pms || "").toString().trim();
            const selPms = (this.selectedColorPms || "").toString().trim();
            return pms !== "" && selPms !== "" && pms === selPms;
        },
        /** Indices to show check: one per list hex, chosen tab only. */
        getFirstMatchIndices(tabIdx) {
            const set = new Set();
            if (!this.colorListValue || !this.colorListValue.length) return set;
            const colors = this.tabColors(tabIdx);
            if (!colors.length) return set;
            for (const listHex of this.colorListValue) {
                const chosenTab = this.getChosenTabForHex(listHex);
                if (chosenTab !== tabIdx) continue;
                const h = this.toHex(listHex);
                if (this.selectedColorId != null) {
                    const selectedIdx = colors.findIndex((c) => c.color_id === this.selectedColorId);
                    if (selectedIdx >= 0 && this.toHex(colors[selectedIdx].color_value) === h) {
                        set.add(selectedIdx);
                        continue;
                    }
                }
                let i = -1;
                if (this.selectedColorPms != null && String(this.selectedColorPms).trim() !== "") {
                    i = colors.findIndex((c) => this.swatchMatchesHexAndPms(c, h));
                }
                if (i < 0) i = colors.findIndex((c) => this.toHex(c.color_value) === h);
                if (i >= 0) set.add(i);
            }
            return set;
        },
        isColorSelected(color, index, tabIdx) {
            if (!color) return false;
            
            const colorHex = this.toHex(color.color_value);
            const sel = this.toHex(this.selectedColor);
            
            if (this.colorListValue && this.colorListValue.length > 0 && tabIdx != null && index != null) {
                const firstMatch = this.getFirstMatchIndices(tabIdx);
                if (firstMatch.has(index)) return true;
                if (firstMatch.size > 0) {
                    const hexMatchesAny = this.colorListValue.some(h => this.toHex(h) === colorHex);
                    if (hexMatchesAny) return false;
                }
            }
            
            if (this.selectedColorId != null && color.color_id != null) {
                if (this.selectedColorId === color.color_id) return true;
            }
            
            if (colorHex === sel) {
                if (this.selectedColorPms != null && color.color_pms != null) {
                    if (this.selectedColorPms === color.color_pms) {
                        if (this.selectedColorId != null && color.color_id != null) {
                            return this.selectedColorId === color.color_id;
                        }
                        return true;
                    }
                    return false;
                }
                return true;
            }
            
            if (color.swatch_file && this.selectedColor === color.swatch_file) {
                return true;
            }
            
            return false;
        },
        /** True if color is black/dark so tick should be white; else black tick. */
        isDarkColor(color) {
            if (!color) return false;
            const hex = this.toHex(color.color_value);
            if (!hex || !/^#[0-9a-f]{6}$/i.test(hex) && !/^#[0-9a-f]{3}$/i.test(hex)) return false;
            const h = hex.slice(1);
            const r = parseInt(h.length === 3 ? h[0] + h[0] : h.slice(0, 2), 16) / 255;
            const g = parseInt(h.length === 3 ? h[1] + h[1] : h.slice(2, 4), 16) / 255;
            const b = parseInt(h.length === 3 ? h[2] + h[2] : h.slice(4, 6), 16) / 255;
            const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
            return luminance < 0.2;
        },
        openFullScreen(tabIndex) {
            const tab = this.tabs[tabIndex];
            const colors = this.tabColors(tabIndex);
            this.$emit("open-fullscreen", { title: tab.label, colors });
        }
    }
};
</script>

<style scoped>
    .available-colors-tabs {
        margin-top: 8px;
        background-color: #fff;
        margin: 0px -12px;
    }

    .available-colors-tabs .available-colors-tabs-head {
        display: flex;
        flex-wrap: wrap;
        gap: 0px;
        border-bottom: 1px solid #D1D1D1;
        padding: 18px 5px;
        margin-bottom: 0px;
    }

    .available-colors-tabs .available-colors-tab {
        padding: 0px 16px;
        border: none !important;
        background: transparent;
        cursor: pointer;
        margin-bottom: -2px;
        border-radius: 0px;
        line-height: 14px;
        border-right: 1px solid #BEBEBE99 !important;
    }
 .available-colors-tabs .available-colors-tab:last-child {
        border-right: none !important;
    }
    .available-colors-tabs .available-colors-tab span {
        border-bottom: 2px solid transparent;
        color: #606060;
        font-size: 14px;
        line-height: 14px;
        padding-bottom: 16px;
    }

    .available-colors-tabs .available-colors-tab:hover {
        color: #333;
    }

    .available-colors-tabs .available-colors-tab.active span {
        color: #0079c1;
        font-weight: 600;
        background: transparent !important;
        border-bottom-color: #0079c1 !important;
    }

    .available-colors-tabs .available-colors-tabs-body {
        /* min-height: 120px; */
        background: #ffffff !important;
        border-radius: 8px;
        padding: 16px;
    }

    .available-colors-tabs .available-colors-tab-panel {
        outline: none;
    }

    .available-colors-tabs .available-colors-panel-inner {
        position: relative;
        border: 1px solid #BEBEBE99;
        padding: 12px 0px 12px 12px;
        border-radius: 4px;
    }

    .available-colors-tabs .available-colors-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        /* min-height: 120px; */
        padding-right: 28px;
        align-content: flex-start;
        border: none;
        padding: 0px;
        margin-top: 16px;
        /* default: no scroll for 10 rows or fewer */
        max-height: none;
        overflow-y: hidden;
        overflow-x: hidden;
    }

    /* When many colors (more than ~10 rows) make the grid scrollable */
    .available-colors-tabs .available-colors-grid.scrollable-grid {
        max-height: 340px;
        overflow-y: auto;
    }

    /* Use native overlay behaviour; keep only Firefox color hint */
    .available-colors-tabs .available-colors-grid.scrollable-grid {
        scrollbar-width: thin;
        scrollbar-color: #929292 transparent;
    }

    .available-colors-tabs .available-colors-grid.has-fullscreen {
        position: relative;
    }

    .available-colors-tabs .fullscreen-trigger {
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
        padding-right: 12px;
    }

    .available-colors-tabs .fullscreen-trigger:hover {
        color: #0079c1;
    }

    .available-colors-tabs .swatch-wrap {
        display: block;
    }

    .design_studio_tool .available-colors-tabs .ui-palette-box .marign_color {
        width: 29px;
        height: 28px;
        margin: 0px;
    }

    .design_studio_tool .available-colors-tabs .ui-palette-box .marign_color:hover {
        margin: 0px !important;
    }

    /* Tick: white/light swatch → black tick; black/dark swatch → white tick */
    .available-colors-tabs .input_color_check_box .form-group input:checked + label:after {
        border-color: #000;
    }
    .available-colors-tabs .input_color_check_box .input_color_check_box_dot_icon {
        background: #000;
    }
    .available-colors-tabs .marign_color.tick-on-dark .input_color_check_box .form-group input:checked + label:after {
        border-color: #fff;
    }
    .available-colors-tabs .marign_color.tick-on-dark .input_color_check_box .input_color_check_box_dot_icon.dot-on-dark {
        background: #fff;
    }
    
    .available-colors-tabs .empty-state-message {
        text-align: left;
        font-weight: normal;
        font-size: 13px;
        line-height: 22px;
        letter-spacing: 0px;
        color: #999;
        opacity: 1;
        padding: 16px 12px;
        min-height: 54px;
        display: flex;
        align-items: center;
    }
    
     @media (max-width: 1300px) {
        .available-colors-tabs .available-colors-tabs-head{
                padding: 18px 0px;
        }
       .available-colors-tabs .available-colors-tab span{
            font-size: 12px;
        }
     }
</style>